import { Controller } from "@hotwired/stimulus";
import * as smsCode from "../lib/sms-code";

export default class extends Controller {
  static targets = ["input"];

  request() {
    smsCode.request();
  }

  inputTargetConnected(input) {
    smsCode.connectInput(input);
  }

  inputTargetDisconnected(input) {
    smsCode.disconnectInput(input);
  }

  sent(event) {
    if (!event.detail.success) smsCode.cancel();
  }

  cancel() {
    smsCode.cancel();
  }
}
